import { Modal, useModals } from 'almanac-ui/Modal'
import { Text } from 'almanac-ui/Text/Text'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import Styles from './IntegrationRequiredModal.module.scss'

import { ArrowOut } from 'almanac-ui/icons'
import { FacebookInitialization, InstagramInitialization } from 'components/IntegrationInitialization'
import { useInitiateOauth } from 'hooks/useInitiateOauth'
import WordPressInitialization from 'components/IntegrationInitialization/WordPressInitialization/WordPressInitialization'

interface IntegrationRequiredModalProps {
  integration: ExternalIntegrationEnum
}

type ValidIntegrations = Exclude<
  ExternalIntegrationEnum,
  | ExternalIntegrationEnum.WordPress
  | ExternalIntegrationEnum.Google
  | ExternalIntegrationEnum.GoogleDrive
  | ExternalIntegrationEnum.GoogleBusinessProfile
  | ExternalIntegrationEnum.MetaAds
  | ExternalIntegrationEnum.GoogleAds
  | ExternalIntegrationEnum.Wix
  | ExternalIntegrationEnum.Zapier
>

const imageUrls: Record<Partial<ValidIntegrations>, string> = {
  [ExternalIntegrationEnum.LinkedIn]: 'https://res.cloudinary.com/almanac/image/upload/v1712242791/LinkedIn_pvpbcu.png',
  [ExternalIntegrationEnum.Instagram]: 'https://res.cloudinary.com/almanac/image/upload/v1712242791/Insta_ukfcqx.png',
  [ExternalIntegrationEnum.X]: 'https://res.cloudinary.com/almanac/image/upload/v1712242792/X_chitr5.png',
  [ExternalIntegrationEnum.Facebook]: 'https://res.cloudinary.com/almanac/image/upload/v1712242790/facebook_wcickx.png',
  [ExternalIntegrationEnum.TikTok]: 'https://res.cloudinary.com/almanac/image/upload/v1712242790/facebook_wcickx.png', // TODO: Replace with TikTok image
  [ExternalIntegrationEnum.YouTube]: 'https://res.cloudinary.com/almanac/image/upload/v1712242790/facebook_wcickx.png', // TODO: Replace with YouTube image
  [ExternalIntegrationEnum.Mailchimp]:
    'https://res.cloudinary.com/almanac/image/upload/v1712242790/facebook_wcickx.png', // TODO: Replace with Mailchimp image
  [ExternalIntegrationEnum.GoHighLevel]:
    'https://res.cloudinary.com/almanac/image/upload/v1712242790/facebook_wcickx.png', // TODO: Replace with GoHighLevel image
  [ExternalIntegrationEnum.Shopify]: 'https://res.cloudinary.com/almanac/image/upload/v1712242790/facebook_wcickx.png', // TODO: Replace with Shopify image
}

export const integrationToName: Record<ExternalIntegrationEnum, string> = {
  [ExternalIntegrationEnum.LinkedIn]: 'LinkedIn',
  [ExternalIntegrationEnum.Instagram]: 'Instagram',
  [ExternalIntegrationEnum.X]: 'X',
  [ExternalIntegrationEnum.WordPress]: 'WordPress',
  [ExternalIntegrationEnum.Facebook]: 'Facebook',
  [ExternalIntegrationEnum.TikTok]: 'TikTok',
  [ExternalIntegrationEnum.YouTube]: 'YouTube',
  [ExternalIntegrationEnum.Mailchimp]: 'Mailchimp',
  [ExternalIntegrationEnum.Google]: 'Google',
  [ExternalIntegrationEnum.GoogleDrive]: 'Google Drive',
  [ExternalIntegrationEnum.GoogleBusinessProfile]: 'Google Business Profile',
  [ExternalIntegrationEnum.MetaAds]: 'Meta Ads',
  [ExternalIntegrationEnum.GoogleAds]: 'Google Ads',
  [ExternalIntegrationEnum.GoHighLevel]: 'GoHighLevel',
  [ExternalIntegrationEnum.Wix]: 'Wix',
  [ExternalIntegrationEnum.Shopify]: 'Shopify',
  [ExternalIntegrationEnum.Zapier]: 'Zapier',
}

export const IntegrationRequiredModal = ({ integration }: IntegrationRequiredModalProps) => {
  const { closeModal } = useModals()
  const { initiateOauth } = useInitiateOauth()
  const text = `We're sending you to ${integrationToName[integration]} real quick to connect your account to Blaze.`

  const handleConnectAccount = () => {
    initiateOauth(integration)
  }

  if (integration === ExternalIntegrationEnum.Facebook) {
    return <FacebookInitialization userIsAttemptingToPost={true} />
  }

  if (integration === ExternalIntegrationEnum.Instagram) {
    return <InstagramInitialization userIsAttemptingToPost={true} />
  }

  if (integration === ExternalIntegrationEnum.WordPress) {
    return <WordPressInitialization />
  }

  const footer = (
    <Modal.Footer>
      <Modal.FooterContent slot="left">
        <Modal.FooterButton variant="tertiary" size="lg" onPress={closeModal}>
          Cancel
        </Modal.FooterButton>
      </Modal.FooterContent>
      <Modal.FooterContent slot="right">
        <Modal.FooterButton size="lg" onPress={handleConnectAccount} endIcon={ArrowOut}>
          Go to {integrationToName[integration]}
        </Modal.FooterButton>
      </Modal.FooterContent>
    </Modal.Footer>
  )

  return (
    <Modal.Root>
      <Modal.Header title="You have to connect your account first" className={Styles.modalHeader} />
      <Modal.Content>
        <Text variant="p1">
          Blaze needs permission to access and publish content to your {integrationToName[integration]} account on your
          behalf.
        </Text>
        <div className={Styles.imageContainer}>
          <div className={Styles.textBox}>
            <Text variant="largeList">{text}</Text>
          </div>
          <img src={imageUrls[integration as ValidIntegrations]} alt="Plaform" className={Styles.image} />
        </div>
      </Modal.Content>
      {footer}
    </Modal.Root>
  )
}
